import { createFileRoute, Navigate } from '@tanstack/react-router';

// redirect to login
export const Route = createFileRoute('/auth/')({
	component: () => {
		// Check if user is logged in by looking for a session token
		const token = localStorage.getItem('auth_token');

		// If no token exists, redirect to login page
		// Otherwise, redirect to dashboard
		return token ? (
			<Navigate to="/dashboard" />
		) : (
			<Navigate to="/auth/login" search={{ redirectTo: '/dashboard' }} />
		);
	},
});
